module.exports = (s) => {
  return {
    rule_name: {
      label: '规则名称',
      type: 'input',
      props: {
        placeholder: '请输入预警配置规则名称',
      },
      value: '',
    },
    channel_type1_list: {
      label: '渠道类型',
      type: 'select',
      props: {
        multiple: true,
        filterable: true,
      },
      options: [],
      value: [],
      on: {
        change: async(value) => {
          s.table_filter.channel_type2_list.value = '';
          s.table_filter.channel_type2_list.options = await s.getChannelType2List(value);
        },
      },
    },
    channel_type2_list: {
      label: '渠道子类型',
      type: 'select',
      props: {
        multiple: true,
        filterable: true,
      },
      options: [],
      value: [],
    },
    channel: {
      label: '渠道标识',
      type: 'input',
      value: '',
    },
    game_id_list: {
      label: '游戏',
      type: 'select-tree',
      props: {
        checkStrictly: false,
        options: [],
        'select-props': {
          placeholder: '请选择',
          size: 'mini',
          clearable: true,
        },
      },
      on: {
        getcheckedValue: (game_ids) => {
          s.table_filter.game_id_list.value = game_ids?.length ? game_ids : null;
        },
      },
      value: null,
    },
  };
};

